import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React from "react";

interface SnackBarMessageProps {
  verticalPlacement?: "top" | "bottom";
  horizontalPlacement?: "left" | "right";
  open: boolean;
  autoHideDuration?: null | number;
  handleClose: () => void;
  messageType?: "success" | "info" | "warning" | "error";
  message: any;
}

export const SnackBarMessage = (props: SnackBarMessageProps) => {
  const {
    verticalPlacement,
    horizontalPlacement,
    open,
    autoHideDuration,
    handleClose,
    messageType,
    message
  } = props;
  return (
    <Snackbar
      anchorOrigin={{
        vertical: verticalPlacement || "top",
        horizontal: horizontalPlacement || "right"
      }}
      open={open}
      autoHideDuration={autoHideDuration || null}
      onClose={handleClose}
    >
      <Alert severity={messageType || "warning"}>{message}</Alert>
    </Snackbar>
  );
};
